import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BulkRoleAssignmentUpload from './BulkRoleAssignmentUpload';

const BulkRoleAssignmentModal = ({ open, onClose, appId, unassignedRoles, mappedRoles, onSuccess }) => {
  const handleSuccess = (count) => {
    if (onSuccess) {
      onSuccess(count);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        }
      }}
    >
      <DialogTitle sx={{ 
        p: 2,
        backgroundColor: 'rgba(25, 118, 210, 0.04)', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Box display="flex" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            Bulk Role Assignment & Edit
          </Typography>
        </Box>
        <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <BulkRoleAssignmentUpload 
          appId={appId} 
          unassignedRoles={unassignedRoles}
          mappedRoles={mappedRoles}
          onSuccess={handleSuccess}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose} 
          sx={{ 
            textTransform: 'none', 
            borderRadius: '6px'
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkRoleAssignmentModal; 